const DEBUG = process.env.REACT_APP_ENABLE_DEBUG || false;
export const debugHelper = {
    log: (message, optionalParams) => {
        if (optionalParams === undefined) DEBUG && console.log(message);
        else DEBUG && console.log(message, optionalParams);
    },
};